import React from "react";
import { Grid, Typography } from "@mui/material";
import "../Styles/CategoryCard.css";
import { useNavigate } from "react-router-dom";

function CategoryCard({ sx, category, image, src }) {
  const navigate = useNavigate();
  return (
    <Grid
      onClick={() => navigate(src)}
      item
      xs={11}
      md={3}
      sx={{
        ...sx,
        height: "500px",
        padding: "10px",
        borderColor: { md: "grey.400" },
      }}
    >
      <div
        id="category"
        style={{
          backgroundImage: `url('${image}')`,
          backgroundSize: "cover",
          backgroundColor: "lightgrey",
          display: "flex",
          height: "100%",
          width: "100%",
          position: "relative",
        }}
      >
        <div
          className="rounded-r-full"
          style={{
            position: "absolute",
            left: 0,
            bottom: 50,
            backgroundColor: "green",
            width: "100px",
            height: "25px",
          }}
        >
          <Typography color="common.white">{category}</Typography>
        </div>
      </div>
    </Grid>
  );
}

export default CategoryCard;
